import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationMap = ({ location, coordinates }) => {
  return (
    <div className="bg-card rounded-xl md:rounded-2xl p-4 md:p-6 border border-border">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Map" size={24} className="text-primary" />
        <h3 className="text-lg md:text-xl font-semibold text-foreground">
          Konum
        </h3>
      </div>
      <div className="mb-4">
        <p className="text-base md:text-lg font-medium text-foreground mb-1">
          {location?.name}
        </p>
        <p className="text-sm text-muted-foreground">
          {location?.address}
        </p>
      </div>
      <div className="w-full h-64 md:h-80 rounded-lg overflow-hidden">
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title={location?.name}
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps?q=${coordinates?.lat},${coordinates?.lng}&z=14&output=embed`}
          className="border-0"
        />
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        <a
          href={`https://www.google.com/maps/dir/?api=1&destination=${coordinates?.lat},${coordinates?.lng}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:opacity-90 transition-opacity"
        >
          <Icon name="Navigation" size={16} />
          Yol Tarifi Al
        </a>
        <button className="inline-flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg text-sm font-medium hover:bg-muted/80 transition-colors">
          <Icon name="Share2" size={16} />
          Konumu Paylaş
        </button>
      </div>
    </div>
  );
};

export default LocationMap;